/**
 * isPalindrome — Verificación de palíndromos
 *
 * Verifica si un string se lee igual de izquierda a derecha
 * que de derecha a izquierda. Usa dos punteros sin reverse().
 *
 * @param {string} inputStr - Texto a verificar
 * @returns {boolean} true si es palíndromo, false si no
 *
 * @example
 * isPalindrome("salas")    // → true
 * isPalindrome("reconocer") // → true
 * isPalindrome("hola")     // → false
 */
export function isPalindrome(inputStr) {
  let left = 0;
  let right = inputStr.length - 1;

  // Dos punteros: uno desde el inicio, otro desde el final.
  // Se mueven hacia el centro comparando los caracteres de ambos extremos.
  while (left < right) {
    // Si los caracteres no coinciden, no es palíndromo
    if (inputStr[left] !== inputStr[right]) {
      return false;
    }
    // Avanzar ambos punteros hacia el centro
    left++;
    right--;
  }

  // Si todos los pares coincidieron, es palíndromo
  return true;
}

/** Casos de prueba oficiales del ejercicio */
export const TEST_CASES = [
  { input: 'aabaa',     expected: true  },
  { input: 'abac',      expected: false },
  { input: 'salas',     expected: true  },
  { input: 'reconocer', expected: true  },
  { input: 'hola',      expected: false },
];
